frappe.list_view_headers = {
    _css_injected: false,

    _inject_responsive_css_once: function (page) {
        if (this._css_injected) return;
        this._css_injected = true;

        const scope = page
            ? `div[id*="${page}\\/List"] > .page-body > .page-toolbar`
            : `.page-body > .page-toolbar`;

        const css = `
        /* Scope: ${scope} */
        ${scope} .custom-list-header-row {
            display: flex !important;
            flex-wrap: wrap !important;
            align-items: flex-start !important;
        }

        ${scope} .custom-header-card {
            box-sizing: border-box !important;
        }

        ${scope} .custom-header-card .indicator-pill {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
            max-width: 100%;
        }

        @media (max-width: 576px) {
            ${scope} .custom-header-card {
                max-width: 100% !important;
                width: 100% !important;
                margin-left: 0 !important;
                margin-right: 0 !important;
                display: block !important;
                height: auto !important;
                margin-bottom: 10px !important;
            }
            ${scope} .custom-header-card .card-body {
                padding: 10px !important;
            }
            ${scope} .custom-header-card .indicator-pill {
                white-space: normal !important;
            }
        }

        /* TABLET: two-per-row */
        @media (min-width: 577px) and (max-width: 900px) {
            ${scope} .custom-header-card {
                max-width: 48% !important;
                width: 48% !important;
                margin-left: 1% !important;
                margin-right: 1% !important;
                margin-bottom: 10px !important;
            }
        }
        `;

        const style = document.createElement("style");
        style.id = "custom-listview-header-responsive-css";
        style.type = "text/css";
        style.appendChild(document.createTextNode(css));
        document.head.appendChild(style);
    },

    add_header_card: function (page_header, title, value, color) {
        let card_html = `
        <div class="card col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12" style="border-top: 4px solid #afafaf; margin: 0; padding: 0; min-height: 90px; height: auto; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); width: 100%; max-width: 100%; box-sizing: border-box; overflow: hidden;">
            <div class="card-body" style="padding: 1.00rem;">
                <h5 class="card-title" style="font-size: 0.9rem; margin-bottom: 0.4rem; line-height: 1.2; text-align: left; white-space: normal; display: block; overflow-wrap: anywhere; word-break: break-word;">${title}</h5>
                <p class="indicator-pill ellipsis ${color}" style="font-size: 0.9rem; margin-bottom: 0;">${value}</p>
            </div>
        </div>`;
        page_header.append(card_html);
    },

    setup_header: function (page, cards) {
        let page_header = $(
            "div[id*='" + page + "\\/List'] > .page-body > .page-toolbar",
        );
        page_header.removeClass("hide");

        page_header = $(
            "div[id*='" +
            page +
            "\\/List'] > .page-body > .page-toolbar > .container",
        );

        page_header
            .addClass("row")
            .css("padding-bottom", "20px")
            .css("width", "100%")
            .css("display", "grid")
            .css("grid-template-columns", "repeat(auto-fit, minmax(260px, 1fr))")
            .css("gap", "16px")
            .css("margin-left", "0")
            .css("margin-right", "0")
            .css("justify-content", "start")
            .css("align-items", "stretch");
        page_header = page_header.empty();

        cards.forEach((card) => {
            this.add_header_card(
                page_header,
                card.title,
                card.value,
                card.color
            );

            if (card.filters) {
                let title = $('h5.card-title').filter(function () {
                    return $(this).html() === card.title;
                });

                title.find('span').each(function () {
                    let text = $(this).text();

                    $(this).css("cursor", "pointer");

                    $(this).hover(
                        function () {
                            $(this).css("color", "#2490ef");
                        },
                        function () {
                            $(this).css("color", "");
                        }
                    );

                    $(this).click(
                        { page: page, filter: card.filters[text] },
                        handle_card_click
                    );
                });
            }
        });
    },
};

function handle_card_click(e) {
    var route = e.data.filter;
    let query_string = frappe.utils.get_query_params();
    if (query_string) {
        route = Object.assign(query_string, route);
    }
    route =
        "?" +
        String(
            Object.entries(route)
                .map(([key, val]) => {
                    if (Array.isArray(val)) {
                        return `${key}=${encodeURIComponent(JSON.stringify(val))}`;
                    }
                    return `${key}=${encodeURIComponent(val)}`;
                })
                .join("&")
        );
    return new Promise((resolve) => {
        frappe.router.push_state(route);
        setTimeout(() => {
            frappe.after_ajax &&
                frappe.after_ajax(() => {
                    resolve();
                });
        }, 100);
    }).finally(() => (frappe.route_flags = {}));
}
